"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonBase = exports.Button = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme");

var _Spinner = require("../Spinner");

var _Typography = require("../Typography");

var _styledSystem = require("styled-system");

var _Button = require("./Button.shared");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** A button with various size and color settings */
var Button =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "getSize",
    value: function getSize() {
      var inline = this.props.inline;

      switch (this.props.size) {
        case "small":
          return {
            height: inline ? "17px" : "26px",
            size: "2",
            px: inline ? 0 : "15px"
          };

        case "medium":
          return {
            height: inline ? "21px" : "41px",
            size: "3t",
            px: inline ? 0 : 2
          };

        case "large":
          return {
            height: inline ? "21px" : "50px",
            size: "3t",
            px: inline ? 0 : 3
          };
      }
    }
  }, {
    key: "getVariant",
    value: function getVariant() {
      switch (this.props.variant) {
        case "primaryBlack":
          return (0, _styledComponents.css)(["", ";"], function (props) {
            var colors = props.theme.colors;
            return "\n                background-color: ".concat(colors.black100, ";\n                border-color: ").concat(colors.black100, ";\n                color: ").concat(colors.white100, ";\n\n                @media ").concat(_Theme.themeProps.mediaQueries.hover, " {\n                  &:hover {\n                    background-color: ").concat(colors.purple100, ";\n                    border-color: ").concat(colors.purple100, ";\n                    color: ").concat(colors.white100, ";\n                  }\n                }\n              ");
          });

        case "primaryWhite":
          return (0, _styledComponents.css)(["", ";"], function (props) {
            var colors = props.theme.colors;
            return "\n                background-color: ".concat(colors.white100, ";\n                border-color: ").concat(colors.white100, ";\n                color: ").concat(colors.black100, ";\n\n                @media ").concat(_Theme.themeProps.mediaQueries.hover, " {\n                  &:hover {\n                    background-color: ").concat(colors.purple100, ";\n                    border-color: ").concat(colors.purple100, ";\n                    color: ").concat(colors.white100, ";\n                  }\n                }\n              ");
          });

        case "secondaryGray":
          return (0, _styledComponents.css)(["", ";"], function (props) {
            var colors = props.theme.colors;
            return "\n                background-color: ".concat(colors.black10, ";\n                border-color: ").concat(colors.black10, ";\n                color: ").concat(colors.black100, ";\n\n                @media ").concat(_Theme.themeProps.mediaQueries.hover, " {\n                  &:hover {\n                    background-color: ").concat(colors.black30, ";\n                    border-color: ").concat(colors.black30, ";\n                    color: ").concat(colors.black100, ";\n                  }\n                }\n              ");
          });

        case "secondaryOutline":
          return (0, _styledComponents.css)(["", ";"], function (props) {
            var colors = props.theme.colors;
            return "\n                background-color: ".concat(colors.white100, ";\n                border-color: ").concat(colors.black10, ";\n                color: ").concat(colors.black100, ";\n\n                @media ").concat(_Theme.themeProps.mediaQueries.hover, " {\n                  &:hover {\n                    background-color: ").concat(colors.white100, ";\n                    border-color: ").concat(colors.black100, ";\n                    color: ").concat(colors.black100, ";\n                  }\n                }\n              ");
          });

        case "noOutline":
          return (0, _styledComponents.css)(["", ";"], function (props) {
            var colors = props.theme.colors;
            return "\n                background-color: transparent;\n                border-color: transparent;\n                color: ".concat(colors.black100, ";\n              ");
          });

        default:
      }
    }
  }, {
    key: "render",
    value: function render() {
      var buttonProps = _objectSpread({}, this.props, this.getSize(), {
        buttonSize: this.props.size,
        variantStyles: this.getVariant()
      });

      return _react.default.createElement(ButtonBase, buttonProps, this.props.children);
    }
  }]);

  return Button;
}(_react.Component);

exports.Button = Button;

_defineProperty(Button, "defaultProps", {
  size: _Button.defaultSize,
  variant: _Button.defaultVariant,
  theme: _Theme.themeProps
});

Button.displayName = "Button";

/** A base from which various button implementations can compose from */
var ButtonBase =
/*#__PURE__*/
function (_Component2) {
  _inherits(ButtonBase, _Component2);

  function ButtonBase() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      if (!_this.props.loading && _this.props.onClick) {
        _this.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(ButtonBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          loading = _this$props.loading,
          disabled = _this$props.disabled,
          color = _this$props.color,
          size = _this$props.size,
          longestText = _this$props.longestText,
          weight = _this$props.weight,
          onClick = _this$props.onClick,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["children", "loading", "disabled", "color", "size", "longestText", "weight", "onClick", "className"]);

      var loadingClass = loading ? "loading" : "";
      var disabledClass = disabled ? "disabled" : "";
      return _react.default.createElement(Container, _extends({
        className: [loadingClass, disabledClass, className].filter(Boolean).join(" "),
        onClick: this.onClick,
        disabled: disabled
      }, rest), loading && _react.default.createElement(_Spinner.Spinner, {
        size: this.props.buttonSize
      }), longestText ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(VisibleText, {
        pt: "1px",
        weight: weight || "medium",
        color: color,
        size: size
      }, children), _react.default.createElement(HiddenText, {
        role: "presentation",
        pt: "1px",
        weight: weight || "medium",
        size: size
      }, longestText)) : _react.default.createElement(_Typography.Sans, {
        pt: "1px",
        weight: weight || "medium",
        size: size
      }, children));
    }
  }]);

  return ButtonBase;
}(_react.Component);

exports.ButtonBase = ButtonBase;

_defineProperty(ButtonBase, "defaultProps", {
  border: 1,
  borderRadius: 3
});

ButtonBase.displayName = "ButtonBase";
var VisibleText = (0, _styledComponents.default)(_Typography.Sans).withConfig({
  displayName: "Button__VisibleText",
  componentId: "sc-1bhxy1c-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
var HiddenText = (0, _styledComponents.default)(_Typography.Sans).withConfig({
  displayName: "Button__HiddenText",
  componentId: "sc-1bhxy1c-1"
})(["opacity:0;pointer-events:none;"]);

var Container = _styledComponents.default.button.withConfig({
  displayName: "Button__Container",
  componentId: "sc-1bhxy1c-2"
})(["cursor:pointer;position:relative;white-space:nowrap;", ";", ";", ";", ";", ";", ";", ";", ";&.loading{transition:none;background-color:transparent;color:transparent;border:0;cursor:auto;}&.disabled{", ";}"], _styledSystem.borders, _styledSystem.borderRadius, _styledSystem.space, _styledSystem.textAlign, _styledSystem.width, _styledSystem.height, function (props) {
  if (!props.loading) {
    return "\n        transition: 0.25s ease;\n      ";
  }
}, function (props) {
  return props.variantStyles;
}, function (props) {
  var colors = props.theme.colors;
  return "\n        background-color: ".concat(colors.black10, ";\n        border-color: ").concat(colors.black10, ";\n        color: ").concat(colors.white100, ";\n        pointer-events: none;\n      ");
});
//# sourceMappingURL=Button.js.map